import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { ExcelRenderer } from 'react-excel-renderer';
import TableSearchwithStudentResult from "../questioners/manage_questin_papers/TableSearchwithStudentResult";
import SampleExcel from '../../../images/eduSample.xls';

const ADD__EDUCATIONAL_STUDENT = gql`
  mutation($params: EduStudentInput) {
    AddEducationalStudents(params: $params)
  }
`;



class AddStudentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      section: "",
      class: "",
      exam: "",
      defaultvalue: 0,
      cols: [],
      rows: [],
      StudentsFilterData: [],
      classError: "",
      examError: "",
      sectionError: "",
      fileError: "",
      dataClear: 0,
      submitError: "",
      loadingSpinner: 0,
      branch: "",
      branchError: ""
    };
  }


  componentDidUpdate() {
    if (this.props.show === true && this.state.dataClear == 0) {
      this.setState({ dataClear: 1, StudentsFilterData: [], rows: [], section: "", class: "", exam: "", classError: "", examError: "", sectionError: "", fileError: "", submitError: "" })
    }
    if (this.props.show === false && this.state.dataClear == 1) {
      this.setState({ dataClear: 0 })
    }
  }



  handleFileChange = e => {
    this.setState({
      StudentsFilterData: [],
      cols: []
    });
    let fileObj = e.target.files[0];
    let fileType = ['application/vnd.ms-excel'];

    if (!fileType.includes(fileObj.type)) {
      this.setState({
        fileError: "Ivalid Format"
      });
      return ""
    }

    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      console.log("res", resp);
      if (err) {
        console.log(err);
      }
      else {
        let studentData = []
        if (resp.rows) {
          let rowData = resp.rows.slice(1);
          if (rowData) {
            rowData.map(item => {
              if (item[0] != undefined && item[0] != undefined && item[2] != undefined) {
                studentData.push({ student_name: item[1].toString(), student_mobile: item[2].toString() })
              }
            });
          }
        }
        this.setState({
          StudentsFilterData: studentData,
          fileError: ""
        });
      }
    });

  }

  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  validateField(fieldName, value) {
    let sectionError = this.state.sectionError;
    let classError = this.state.classError;
    let examError = this.state.examError;
    let section = this.state.section;
    let classvalue = this.state.class;
    let examValue = this.state.exam
    let branchError = this.state.branchError;
    let branchValue = this.state.branch

    switch (fieldName) {
      case "section":
        if (value == 0) {
          sectionError = "Select Section";
          section = "";
        } else {
          sectionError = "";
        }

        break;

      case "class":
        if (value == 0) {
          classError = "Select Class";
          classvalue = "";

        } else {
          classError = "";
        }
        break;

      case "exam":
        if (value == 0) {
          examError = "Select Exam";
        } else {
          examError = "";
        }
        break;

      case "branch":
        if (value == 0) {
          branchError = "Select branch";
        } else {
          branchError = "";
        }
        break;

      default:
        break;
    }
    this.setState(
      {
        sectionError: sectionError,
        classError: classError,
        examError: examError,
        class: classvalue,
        exam: examValue,
        section: section,
        branchError: branchError,
        branchValue: branchValue
      },
    );
  }



  handleFormSubmit = e => {

    console.log("this.state.StudentsFilterData", this.state.StudentsFilterData);


    if (this.state.branch === "") {
      this.setState({ branchError: "Select branch" });
      return ""
    }

    if (this.state.class === "") {
      this.setState({ classError: "Select class" });
      return ""
    }

    if (this.state.exam === "") {
      this.setState({ examError: "Select exam" });
      return ""
    }

    if (this.state.section === "") {
      this.setState({ sectionError: "Select section" });
      return ""
    }


    if (!this.state.StudentsFilterData.length) {
      this.setState({ fileError: "Upload file" });
      return ""
    }


    e.preventDefault();
    let params = {
      section_id: parseInt(this.state.section),
      class_id: parseInt(this.state.class),
      exam_id: parseInt(this.state.exam),
      branch_id: parseInt(this.state.branch),
      institute_id: parseInt(Cookies.get("institutionid")),
      student_details: this.state.StudentsFilterData,
    };
    console.log("params", params);

    this.addStudent(params).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message)
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map(x => x.message)
      );
      setTimeout(() => {
        this.props.onHide();
      }, 5000);
    });

  };

  addStudent = async params => {
    console.log("child");
    await this.props.addStudent({
      variables: {
        params
      },
      update: (store, { data }) => {
        if (data.AddEducationalStudents) {
          this.setState({
            loadingSpinner: 1,
            currentStep: 5,
          });

          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      }
    });
  };


  

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
    this.props.onHide();
    window.location.reload(false);
  };


  articlecolumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
    },
    {
      dataField: "student_mobile",
      text: "Mobile",
      sort: true,
    },
  ];


  render() {
    console.log("this.props", this.state);
    if (this.props.globals == undefined) return null;
    let sections = [];
    if (this.state.exam != "") {
      this.props.globals.globalPackages.map((item) => {
        if (item.exams_covered == this.state.exam) {
          this.props.globals.globalCategories.map((stumap) => {
            if (stumap.package_id == item.id) {
              this.props.globals.globalSections.map((stumap1) => {
                if (stumap1.category_id == stumap.id) {
                  const newObj = {
                    id: stumap1.id,
                    section_name: stumap1.section_name
                  }
                  sections.push(newObj);
                }
              })

            }

          });
        }
      });
    }

    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Student</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form>
            <Form.Row>
              <Form.Group
                as={Col}
                lg={3}
                md={12}
                sm={12}
                controlId="SelectClass"
              >
                <Form.Label className="text-uppercase">Branch</Form.Label>
                <Form.Control
                  as="select"
                  name="branch"
                  onChange={this.handleInputChange}
                  value={this.state.branch}
                >
                  <option value={this.state.defaultvalue}>--Select Branch--</option>
                  {this.props.globals.globalBranches.map(branchData => (
                    <option value={branchData.id}>{branchData.branch_name}</option>
                  ))}
                </Form.Control>
                <Form.Text className="form-text text-danger">
                  {this.state.branchError}
                </Form.Text>
              </Form.Group>
              <Form.Group
                as={Col}
                lg={3}
                md={12}
                sm={12}
                controlId="SelectClass"
              >
                <Form.Label className="text-uppercase">Class</Form.Label>
                <Form.Control
                  as="select"
                  name="class"
                  onChange={this.handleInputChange}
                  value={this.state.class}
                >
                  <option value={this.state.defaultvalue}>--Select class--</option>
                  {this.props.globals.classes.map(classdata => (
                    <option value={classdata.id}>{classdata.class}</option>
                  ))}
                </Form.Control>
                <Form.Text className="form-text text-danger">
                  {this.state.classError}
                </Form.Text>
              </Form.Group>
              <Form.Group
                as={Col}
                lg={3}
                md={12}
                sm={12}
                controlId="Selectexam"
              >
                <Form.Label className="text-uppercase">Exam</Form.Label>
                <Form.Control
                  as="select"
                  name="exam"
                  onChange={this.handleInputChange}
                  value={this.state.exam}
                >
                  <option value={this.state.defaultvalue}>--Select Exam--</option>
                  {this.props.globals.exams.map(item => (
                    <option value={item.id}>
                      {item.exam}
                    </option>
                  ))}
                </Form.Control>
                <Form.Text className="form-text text-danger">
                  {this.state.examError}
                </Form.Text>
              </Form.Group>

              <Form.Group
                as={Col}
                lg={3}
                md={12}
                sm={12}
                controlId="SelectSection"
              >
                <Form.Label className="text-uppercase">Section</Form.Label>
                <Form.Control
                  as="select"
                  name="section"
                  onChange={this.handleInputChange}
                  value={this.state.section}
                >
                  <option value={this.state.defaultvalue}>--Select Section--</option>
                  {sections.map(sectiondata => (

                    <option value={sectiondata.id}>
                      {sectiondata.section_name}
                    </option>)
                  )}
                </Form.Control>
                <Form.Text className="form-text text-danger">
                  {this.state.sectionError}
                </Form.Text>
              </Form.Group>
              <Form.Group controlId="formFile" as={Col}
                lg={3}
                md={12}
                sm={12}>
                <Form.Label ><a href={SampleExcel} download>Download sample file</a></Form.Label>
                <Form.Control name="file" type="file" onChange={this.handleFileChange} >
                </Form.Control>
                <Form.Text className="form-text text-danger">
                  {this.state.fileError}
                </Form.Text>
              </Form.Group>
            </Form.Row>
          </Form>
        </Modal.Body>
        <Card>
          <TableSearchwithStudentResult
            parentData={this.state.StudentsFilterData}
            particlecolumns={this.articlecolumns}
            defaultSorted={{ dataField: "contenttype", order: "desc" }}
          />
        </Card>
        <Modal.Footer variant="white" className="px-4">
          <Row>
            <Col sm={12}>
              {this.state.currentStep == 5 ? (
                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                  Student Data Saved successfully
                </Form.Text>
              ) : (
                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                  {this.state.submitError}
                </Form.Text>
              )}
            </Col>
            <Col sm={12} style={{ display: "block", textAlign: "center" }}>
              <Button
                className="btn btn-success text-uppercase"
                onClick={this.handleFormSubmit}

              >
                {
                  this.state.loadingSpinner == 1 ?
                    (<div class="spinner-border text-light  loading-img-center"></div>)
                    :
                    ("")
                }
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default graphql(ADD__EDUCATIONAL_STUDENT, {
  name: "addStudent"
})(AddStudentModal);
